import DescriptionIcon from "@mui/icons-material/Description";
import { BaseDetailModal } from "./BaseDetailModal";

export function MemoModal(props) {
  return (
    <BaseDetailModal
      {...props}
      title="Memo Details"
      sectionLabel="Message"
      icon={DescriptionIcon}
      iconBgColor="bg-blue-50"
      iconColor="text-blue-600"
    />
  );
}